import { SiX } from '@icons-pack/react-simple-icons';
import {
  AudioWaveformIcon,
  BrainIcon,
  CircuitBoardIcon,
  DatabaseIcon,
  FileIcon,
  ImageIcon,
  SlashIcon,
  TextIcon,
  VideoIcon,
  WrenchIcon,
} from 'lucide-react';

export const nodeButtons = [
  {
    id: 'text',
    label: 'Text',
    icon: TextIcon,
  },
  {
    id: 'image',
    label: 'Image',
    icon: ImageIcon,
  },
  {
    id: 'audio',
    label: 'Audio',
    icon: AudioWaveformIcon,
  },
  {
    id: 'video',
    label: 'Video',
    icon: VideoIcon,
  },
  {
    id: 'file',
    label: 'File',
    icon: FileIcon,
  },
  {
    id: 'divider-1',
    label: 'Divider',
    icon: SlashIcon,
  },
  {
    id: 'llm',
    label: 'LLM',
    icon: BrainIcon,
    color: 'text-lime-500 dark:text-lime-400',
  },
  // {
  //   id: 'code',
  //   label: 'Code',
  //   icon: CodeIcon,
  //   data: {
  //     content: { language: 'javascript' },
  //   },
  // },
  {
    id: 'tool',
    label: 'Tool',
    icon: WrenchIcon,
    color: 'text-cyan-500 dark:text-cyan-400',
  },
  {
    id: 'agent',
    label: 'Agent',
    icon: CircuitBoardIcon,
    color: 'text-emerald-500 dark:text-emerald-400',
  },
  {
    id: 'memory',
    label: 'Memory',
    icon: DatabaseIcon,
    color: 'text-sky-500 dark:text-sky-400',
  },
  {
    id: 'divider-2',
    label: 'Divider',
    icon: SlashIcon,
  },
  {
    id: 'tweet',
    label: 'Tweet',
    icon: SiX,
  },
];
